<template>
  <nav class="breadcrumb-row" :class="theme" aria-label="Breadcrumb">
    <template v-for="(item, i) in items">
      <router-link v-if="item.to" :key="'link-' + i" :to="item.to" class="breadcrumb-link">{{ item.label }}</router-link>
      <span v-else :key="'cur-' + i" class="breadcrumb-current" aria-current="page">{{ item.label }}</span>
      <span v-if="i < items.length - 1" :key="'sep-' + i" class="breadcrumb-sep" aria-hidden="true">/</span>
    </template>
  </nav>
</template>

<script>
export default {
  name: "AppBreadcrumbs",
  props: {
    items: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: "light",
      validator: v => ["light", "dark"].includes(v)
    }
  }
};
</script>

<style scoped>
.breadcrumb-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
}

/* Light theme (used on white/fafafa hero pages) */
.breadcrumb-row.light {
  color: #6b7280;
}
.breadcrumb-row.light .breadcrumb-link {
  font-weight: 600;
  color: #096843;
  text-decoration: none;
}
.breadcrumb-row.light .breadcrumb-link:hover {
  text-decoration: underline;
}
.breadcrumb-row.light .breadcrumb-current {
  color: #6b7280;
}

/* Dark theme (used on dark plan-photo hero pages) */
.breadcrumb-row.dark {
  color: rgba(255, 255, 255, 0.75);
}
.breadcrumb-row.dark .breadcrumb-link {
  font-weight: 700;
  color: #b7f0cf;
  text-decoration: none;
}
.breadcrumb-row.dark .breadcrumb-link:hover {
  color: #ffffff;
}
.breadcrumb-row.dark .breadcrumb-current {
  color: rgba(255, 255, 255, 0.85);
}

.breadcrumb-sep {
  opacity: 0.5;
}
</style>
